'use client';
import { useState } from 'react';
import SegmentedToggle, { SegmentedToggleOption } from '@/app/components/SegmentedToggle';
import './page.css'

type Country = 'netherlands' | 'belgium';

const countryOptions: SegmentedToggleOption<Country>[] = [
    {value: 'netherlands', label: 'Netherlands'},
    {value: 'belgium', label: 'Belgium'},
];

const rdServiceUrls = (
    <>
        <h5 id="WxOtm">Service URLs per year for RD</h5>
        <p>From 2024 onwards (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2024 or later):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/lufo<b><span className="colors-s-ouao">YYYY</span></b>tiled/tiles/tile/pwecmhoslufostorage/nl-<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpeg</pre>
        <p>From 2016-2023 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2016, 2017, 2018, 2019, 2020, 2021, 2022, or 2023):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/lufo<b><span className="colors-s-ouao">YYYY</span></b>tiled/tiles/tile/pwecmhoslufostorage/lufo<b><span className="colors-s-ouao">YYYY</span></b>tiled/lufo<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpg</pre>
        <p>2013-2015 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2013, 2014, or 2015):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/<b><span className="colors-s-ouao">YYYY</span></b>_tiled/tiles/tile/pwecmhoslufostorage/lufo<b><span className="colors-s-ouao">YYYY</span></b>tiled/<b><span className="colors-s-ouao">YYYY</span></b>_tiled/##z##/##x##/##y##.jpg</pre>
    </>
);

const nlWebMercatorServiceUrls = (
    <>
        <p></p>
        <h5 id="zxSI4">Service URLs per year for Web Mercator</h5>
        <p>From 2024 onwards (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2024 or later):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/<b><span className="colors-s-ouao">YYYY</span></b>_tiled_mercator/tiles/tile/pwecmhoslufostorage/nl-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpeg</pre>
        <p>2016, 2017, 2020, 2021, 2022, 2023 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2016, 2017, 2020, 2021, 2022, or 2023):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/<b><span className="colors-s-ouao">YYYY</span></b>_tiled_mercator/tiles/tile/pwecmhoslufostorage/nl-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled/nl-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpg</pre>
        <p>2018, 2019 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2018, 2019):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/<b><span className="colors-s-ouao">YYYY</span></b>_tiled_mercator/tiles/tile/pwecmhoslufostorage/nl-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled2/nl-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled2/##z##/##x##/##y##.jpg</pre>
        <p>2015:</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/<b><span className="colors-s-ouao">2015</span></b>_tiled_mercator/tiles/tile/pwecmhoslufostorage/nl-mercator<b><span className="colors-s-ouao">2015</span></b>tiled/<b><span className="colors-s-ouao">2015</span></b>_tiled_mercator//##z##/##x##/##y##.jpg</pre>
    </>
);

const beWebMercatorServiceUrls = (
    <>
        <p></p>
        <h5 id="zxSI5">Service URLs per year for Web Mercator</h5>
        <p>2024, 2026 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2024 or 2026):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/be-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled/tiles/tile/pwecmhoslufostorage/be-mercator<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpeg</pre>
    </>
);

const belgianLambertServiceUrls = (
    <>
        <h5>Service URLs per year for Belgian Lambert 72</h5>
        <p>2024, 2026 (replace <b><span className="colors-s-ouao">YYYY</span></b> by 2024 or 2026):</p>
        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/be-<b><span className="colors-s-ouao">YYYY</span></b>tiled/tiles/tile/pwecmhoslufostorage/be-<b><span className="colors-s-ouao">YYYY</span></b>tiled/##z##/##x##/##y##.jpeg</pre>
    </>
);

function AerialMapServicePage() {
    const [country, setCountry] = useState<Country>('netherlands');

    return (
        <section className="pazlkchmsn">
            <div className="xjxghidyhk">
                <div className="vshugkagez" role="main">
                    <div className="flex flex-column flex-grow fill block">
                        <section className="dayijnovoy dayijnovoy-xl">
                            <div className="jnznarkcjk jnznarkcjk-xl jnznarkcjk-lg">
                                <div className="tefxiomanc tefxiomanc-xl" role="article">
                                    <div className="card card-wiogy xntleozynm">
                                        <div className="table">
                                            <div className="sdnneeslai">
                                                <div className="dxffefactr">
                                                    <div className="ProseMirror">
                                                        <h1 id="SXd3f" className="text text-xl-align-left"><b>Aerial Map
                                                                Service</b></h1>
                                                        <p>With our Aerial Map Service, you can use Cyclomedia aerial imagery
                                                            in your own mapping application (GIS). The
                                                            service is available as a Web Map Service (WMS), or as a
                                                            Tile Map Service (TMS).</p>
                                                        <p><i><span className="colors-s-ouao">Note: the Aerial Map Service
                                                                    is currently only available for the
                                                                    Netherlands and Belgium.</span></i></p>
                                                        <p></p>
                                                    </div>
                                                </div>
                                                <div className="nljvpdbuak"><img className="picture picture-rmxnk"
                                                        src="/images/DP-AerialMapServices.jpg" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ProseMirror">
                                        <p></p>
                                        <h5 id="XJZQa"></h5>
                                    </div>
                                </div>
                                <div className="oycaxboibw oycaxboibw-xl" role="article">
                                    <div className="placeholder"></div>
                                </div>
                            </div>
                        </section>
                        <section className="fdkevjciln">
                            <div className="qdrgnmyfpp qdrgnmyfpp-md qdrgnmyfpp-lg">
                                <div className="urkkpstrtp urkkpstrtp-md" role="article"><img
                                        className="picture picture-default"
                                        src="/images/Cyclomedia_icons_key_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120" />
                                    <div className="ProseMirror">
                                        <h3 id="cXbTu" className="text text-xl-align-center text text-align-center">
                                            <b>Obtain credentials</b></h3>
                                        <p className="text text-xl-align-center text text-align-center">Before you can start
                                            using the Aerial Map Service, you need to have credentials. If you do not
                                            have them yet, please <a href="https://info.cyclomedia.com/developerrequest" target="_self">use this form
                                                to request access</a>.</p>
                                    </div><a role="button" href="https://info.cyclomedia.com/developerrequest" target="_self"
                                        className="button button-primary ibvngcvzho"><span data-bind="text: label">Request
                                            your credentials</span></a>
                                </div>
                                <div className="tkexthlmvi tkexthlmvi-md" role="article"><img
                                        className="picture picture-default"
                                        src="/images/Cyclomedia_icons_files_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120" />
                                    <div className="ProseMirror">
                                        <h3 id="mio7U" className="text text-xl-align-center text text-align-center"><b>Read
                                                the documentation</b></h3>
                                        <p className="text text-align-center">Everything you need to know about the use of
                                            our Aerial Map Service can be found below in the <a
                                                href="/our-apis/aerial-map-service#klz6S" target="_self">Service
                                                Documentation</a>.</p>
                                    </div><a role="button" href="/our-apis/aerial-map-service#klz6S" target="_self"
                                        className="button button-primary wpajzwwajn"><span data-bind="text: label">Read the
                                            service documentation</span></a>
                                </div>
                                <div className="rwecujswjm rwecujswjm-md" role="article"><img
                                        className="picture picture-default"
                                        src="/images/Cyclomedia_icons_lamp_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120" />
                                    <div className="ProseMirror">
                                        <h3 id="1ziwS" className="text text-xl-align-center text text-align-center"><b>View
                                                our examples</b></h3>
                                        <p className="text text-xl-align-center text text-align-center">To help you getting
                                            started, we have created a set of code examples for you. You can use them as
                                            a basis for your own service requests.</p>
                                    </div><a role="button" href="/our-apis/aerial-map-service#0zrsz" target="_self"
                                        className="button button-primary tnrucuaqvl"><span data-bind="text: label">Explore
                                            the code examples</span></a>
                                </div>
                            </div>
                        </section>
                        <section className="cjmedgohcg cjmedgohcg-xl">
                            <div className="nsxkzqdvul nsxkzqdvul-lg">
                                <div className="zhrybmlmwp" role="article">
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p></p>
                                        <h1 id="klz6S" className="text text-xl-align-center"><b><span
                                                    className="colors-default-bg">Service Documentation</span></b></h1>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="zdzxzhyiij zdzxzhyiij-xl">
                            <div className="rlxwwbwcvj rlxwwbwcvj-xl rlxwwbwcvj-lg rlxwwbwcvj-md">
                                <div className="ioedmtjmsr ioedmtjmsr-md ioedmtjmsr-xl" role="aside"><img
                                        className="picture picture-default qvqdjezjcq"
                                        src="/images/Katwijk-401_1861_00001417-E-s.jpg" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <h2 id="y9o3w"><b>Understanding TMS pyramids</b></h2>
                                        <p>As a Tile Map Service (TMS), all imagery is pre-rendered and stored as tiles
                                            in a pyramid grid format. Each tile is 256 x 256 pixels in size.</p>
                                        <p>Three pyramids are supported, one for the RD coordinate system
                                            (&apos;Rijksdriehoekstelsel&apos;, EPSG: 28992) defined by Geonovum, one for Web
                                            Mercator (EPSG: 3057, sometimes also known as EPSG: 900913) and one for the &apos;Belgian Lambert 72&apos; (EPSG:31370).</p>
                                        <p>The Geonovum pyramid is defined as:</p>
                                    </div><img className="picture picture-default fhyrfcmzyg"
                                        src="/images/TMS-Pyramids-geonovum.svg" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>The Google Web Mercator pyramid is defined as:</p>
                                    </div><img className="picture picture-default mkswgcmvcz"
                                        src="/images/TMS-Pyramids-google.svg" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>The Belgian Lambert 72 pyramid is defined as:</p>
                                    </div>
                                    <img className="picture picture-default mkswgcmvcz" src="/images/aerial-map-be-lambert-pyramid.png" />
                                </div>
                                <div className="hftbvscrro hftbvscrro-md hftbvscrro-xl" role="article">
                                    <div className="ProseMirror">
                                        <h2 id="6qEhx"><b>About the Aerial Map Service</b></h2>
                                        <p>For customers in the Netherlands that use our aerial imagery (LuchtfotoNL),
                                            we offer this data also as a web service in various OGC standards. This
                                            allows you to load the data into your GIS application by using one of the
                                            service URLs explained below.</p>
                                        <p>Authentication is done through basic authentication with a username and
                                            password. You need to add this to your service configuration, or add it to
                                            each service request.</p>
                                    </div>
                                    <SegmentedToggle label="Country" options={countryOptions} value={country}
                                                     onChange={setCountry} fullWidth />
                                    <div className="ProseMirror">
                                        <h4 id="HbVFE">Web Map Service (WMS)</h4>
                                        <p>The URL of the Aerial Map Service in WMS format is:</p>
                                        <pre>https://atlasapi.cyclomedia.com/api/geodata/wms</pre>
                                        <p>Imagery of each year is provided as separate layers, for example
                                        &apos;NL_aerial_2018_10cm&apos; for the year 2018. By using a GetCapabilities request,
                                            you can retrieve a list of all available layers.</p>
                                        <p><i><span className="colors-s-ouao">For more information about the WMS standard,
                                                    see the OGC documentation:
                                                    https://www.ogc.org/standard/wms/</span></i></p>
                                        <h4 id="go5zc">Tile Map Service (TMS)</h4>
                                        <p>The TMS is served for three coordinate systems: RD (EPSG: 28992) (Dutch layers only), 
                                            Belgian Lambert 72 (EPSG: 31370) (Belgium layers only) and Web Mercator (EPSG: 3857). 
                                            The difference between the two is explained in more detail in the section &apos;
                                            <a href="/our-apis/aerial-map-service#y9o3w" target="_self">Understanding TMS pyramids</a>&apos;.<br/>
                                        </p>
                                        {country === 'netherlands' ? (
                                            <>
                                                {rdServiceUrls}
                                                {nlWebMercatorServiceUrls}
                                            </>
                                        ) : (
                                            <>
                                                {beWebMercatorServiceUrls}
                                                {belgianLambertServiceUrls}
                                            </>
                                        )}
                                    </div>
                                    <div className="ProseMirror">
                                        <p><i><span className="colors-s-ouao">For more information about the TMS standard,
                                                    see: https://en.wikipedia.org/wiki/Tile_Map_Service</span></i></p>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="fonhgmgahw fonhgmgahw-xl">
                            <div className="xbjdoucesd xbjdoucesd-lg">
                                <div className="emmaqmmaqc" role="article">
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p></p>
                                        <h1 id="0zrsz" className="text text-xl-align-center"><b><span
                                                    className="colors-default-bg">Code examples</span></b></h1>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="txrohrfutu txrohrfutu-xl">
                            <div className="jgzpagxabd jgzpagxabd-lg">
                                <div className="rozudcmena" role="article">
                                    <div className="ProseMirror">
                                        <p></p>
                                        <h4 id="aTwKn" className="text text-xl-align-center"><i><span
                                                    className="colors-iylvo">Note: you can use <a
                                                        href="https://web.postman.co" target="_blank"
                                                        rel="noopener noreferrer">Postman</a> to test our web services and try out the
                                                    code examples below.</span></i><span className="colors-iylvo"></span>
                                        </h4>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="wfxrcufznp">
                            <div className="cbxobvjfwq cbxobvjfwq-lg cbxobvjfwq-md">
                                <div className="vzojbwdqul vzojbwdqul-md vzojbwdqul-xl" role="aside">
                                    <div className="ProseMirror">
                                        <h2 id="TfiEe"><b>Retrieve a TMS tile in RD</b></h2>
                                        <p>Retrieve an aerial imagery tile from TMS in RD coordinates.</p>
                                        <p></p>
                                    </div>
                                </div>
                                <div className="qxzcwoacqb qxzcwoacqb-md qxzcwoacqb-xl" role="article">
                                    <div className="ProseMirror">
                                        <h4 id="rfq6r">Example requests for an aerial TMS tile in RD:</h4>
                                        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/lufo2016tiled/tiles/tile/pwecmhoslufostorage/lufo2016tiled/lufo2016tiled/13/4158/3354.jpg</pre>
                                        <p>The output for this request is the following tile:</p>
                                    </div><img className="picture picture-default xzqhuyiedn"
                                        src="/images/example-aerialmapservice-tms-rd-1.jpg" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/lufo2021tiled/tiles/tile/pwecmhoslufostorage/lufo2021tiled2/lufo2021tiled2/13/4158/3355.jpg</pre>
                                        <p>The output for this request is the following tile:</p>
                                    </div><img className="ibevmhkduv" src="/images/example-aerialmapservice-tms-rd-2.jpg" />
                                </div>
                            </div>
                        </section>
                        <section className="lwntsxhevd lwntsxhevd-xl">
                            <div className="bmhmihejqk bmhmihejqk-xl bmhmihejqk-lg bmhmihejqk-md">
                                <div className="ajmmkwutdi ajmmkwutdi-md ajmmkwutdi-xl" role="aside">
                                    <div className="ProseMirror">
                                        <h2 id="TfiEe"><b>Retrieve a TMS tile in Web Mercator</b></h2>
                                        <p>Retrieve an aerial imagery tile from TMS in Web Mercator coordinates.</p>
                                        <p></p>
                                    </div>
                                </div>
                                <div className="mdmnzbtufg mdmnzbtufg-md mdmnzbtufg-xl" role="article">
                                    <div className="ProseMirror">
                                        <h4 id="ZoUxA">Example request for an aerial TMS tile in Web Mercator</h4>
                                        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/2021_tiled_mercator/tiles/tile/pwecmhoslufostorage/nl-mercator2021tiled/nl-mercator2021tiled/19/270123/174495.jpg</pre>
                                        <p>The output for this request is the following tile:</p>
                                    </div>
                                    <img className="picture picture-default rtbsdzzpna" src="/images/example-aerialmapservice-tms-wm-1.jpg" />
                                    <div className="ProseMirror">
                                    <h4 id="ZoUxA">Retrieve a TMS tile in Belgian Lambert 72</h4>
                                        <pre>https://atlasapi.cyclomedia.com/api/image/tms/layer/be-2024tiled/tiles/tile/pwecmhoslufostorage/be-2024tiled/12/983/3205.jpeg</pre>
                                        <p>The output for this request is the following tile:</p>
                                    </div>
                                    <img className="picture picture-default rtbsdzzpna" src="/images/aerial-map-belgian-lamber-tms.jpg" />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AerialMapServicePage